export default {
    /* GET_PRODUCT_GROUP_FACTOR
    ---------------------------------------------------------------
    */
    GET_PRODUCT_GROUP_FACTORS_REQUEST: (state) => {
        state.productGroupFactorsLoading = true
    },
    GET_PRODUCT_GROUP_FACTORS_SUCCESS: (state, data) => {
        state.productGroupFactors = data
        state.productGroupFactorsLoading = false
    },
    GET_PRODUCT_GROUP_FACTORS_FAILURE: (state) => {
        state.productGroupFactorsLoading = false
    },
    SET_PRODUCTS_GROUP_FACTORS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PRODUCTS_GROUP_FACTORS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}